import './src/styles/global.css';

window.gtag ??= (...args) => {
  console.log('gtag', args);
};
